import { DataService, PamlabApiServiceService } from '@/shared/services';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { TransferStudentFilterOptions } from 'src/server/types';

@Component({
  selector: 'transfer-enrollment-trends-form',
  templateUrl: './transfer-enrollment-trends-form.component.html',
  styleUrl: './transfer-enrollment-trends-form.component.css',
  standalone: false,
})
export class TransferEnrollmentTrendsFormComponent implements OnInit {
  transfersForm = new FormGroup({
    admit_type: new FormControl<string>('all'),
    associate_degree: new FormControl<string>('all'),
    full_part_time_ind: new FormControl<string>('all'),
    graduation_time: new FormControl<string>('three-years'),
    college: new FormControl<string>('all'),
    department: new FormControl<string>('all'),
    program: new FormControl<string>('all'),
    transfer_college_name: new FormControl('all'),
  });
  initDataFilterOptions!: TransferStudentFilterOptions;
  dataFilterOptions: TransferStudentFilterOptions = {
    associate_degrees: [],
    admit_types: [],
    colleges: [],
    departments: [],
    full_part_time_inds: [],
    graduation_times: [],
    programs: [],
    transfer_colleges_names: [],
  };
  loadingFilterOptions: boolean = false;

  constructor(
    private dialog: MatDialog,
    private apiService: PamlabApiServiceService,
    private dataService: DataService,
  ) {}

  ngOnInit(): void {
    this.loadingFilterOptions = true;
    this.apiService.fetchTransferEnrollmentTrendsFilterOptions().subscribe({
      next: (data) => {
        this.dataFilterOptions = data;
        this.initDataFilterOptions = JSON.parse(JSON.stringify(data));
        this.loadingFilterOptions = false;
      },
    });
  }

  submitForm() {
    // This call's sole purpose is to log the query to the database
    this.apiService
      .fetchTransferEnrollmentTrends(this.transfersForm.value)
      .subscribe();
    // Send form data to data service. This will trigger the subscription in the content component to ran, filter, and update the data on the tables and charts
    this.dataService.setTransferStudentsFilters(this.transfersForm.value);
  }

  // To determine what college user choose to change program option for form field
  onCollegeChange() {
    const college = this.transfersForm.value.college;
    this.transfersForm.patchValue({ department: 'all', program: 'all' });

    if (!college) {
      this.dataFilterOptions.departments = [];
    } else {
      this.dataFilterOptions.departments =
        this.initDataFilterOptions.departments.filter(
          (x) => x.college === college,
        );
    }
    this.dataFilterOptions.programs = [];
  }

  onDepartmentChange() {
    const department = this.transfersForm.value.department;
    const college = this.transfersForm.value.college;
    this.transfersForm.patchValue({ program: 'all' });

    if (!department) {
      this.dataFilterOptions.programs = [];
    } else {
      this.dataFilterOptions.programs =
        this.initDataFilterOptions.programs.filter(
          (x) => x.department === department && x.college === college!,
        );
    }
  }

  closeDialog() {
    this.dialog.closeAll();
  }
}
